<app-select-input
  [controlName]="controlName"
  [controlLabel]="controlLabel"
  [formGroup]="formGroup"
  [options]="states"
  optionValueKey="stateName"
  [multiple]="multiple"
  (selectionChange)="onSelectionChanged($event)"
  (openedChange)="onOpenedChanged($event)">
</app-select-input>
